var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container live-container" },
    [
      _c("navbar", { attrs: { active: "live" } }),
      _vm._v(" "),
      _c("live-box"),
      _vm._v(" "),
      _vm.roomSize > 0
        ? _c("h3", [
            _c("img", {
              attrs: {
                src: "//image.micoworld.net/61f547b6487204a0fb96d587f36a3e46",
                alt: "hot",
              },
            }),
            _vm._v("\n    " + _vm._s(_vm.text.hot_live) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("list"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }